import { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";

export default function Particle() {
    const [init, setInit] = useState(false);
    const [colors, setColors] = useState({
        particleColor: "#bae6fd",
        linkColor: "#bae6fd"
    })

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadFull(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    useEffect(() => {


        const handleModeChange = () => {
            if (!document.body.classList.contains("dark")) {
                setColors({
                    particleColor:"#000000",
                    linkColor: "#000000"
                    // linkColor:"#60a5fa"
                }
                )
            }
            else {
                setColors({
                    particleColor:"#bae6fd",
                    linkColor:"#e0f2fe"
                })

            }
        }

        handleModeChange();

        
        const observer = new MutationObserver( () => {
            handleModeChange();
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"]
        });

        return () => {
            observer.disconnect();
        }

    }, [])

    const particlesLoaded = (container) => { };

    return (
        <>
            {init && (
                <Particles
                    particlesLoaded={particlesLoaded}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                    options={{
                        fullScreen: { enable: false },
                        fpsLimit: 120,
                        interactivity: {
                            events: {
                                onClick: {
                                    enable: false, // Disable click interaction
                                },
                                onHover: {
                                    enable: false, // Disable hover interaction
                                },
                                resize: true,
                            },
                        },
                        particles: {
                            color: {
                                // value: "#bae6fd",
                                // value: "#1e3a8a"
                                value: colors.particleColor
                            },
                            links: {
                                // color: "#e0f2fe",
                                // color: "#60a5fa",
                                color: colors.linkColor,
                                distance: 150,
                                enable: true,
                                opacity: 0.5,
                                width: 1,
                            },
                            move: {
                                direction: "none",
                                enable: true,
                                outModes: {
                                    default: "bounce",
                                },
                                random: false,
                                speed: 1.2,
                                straight: false,
                            },
                            number: {
                                density: {
                                    enable: true,
                                    area: 800,
                                },
                                value: 160,
                            },
                            opacity: {
                                value: 0.3,
                            },
                            shape: {
                                type: "circle",
                            },
                            size: {
                                value: { min: 1, max: 5 },
                            },
                        },
                        detectRetina: true,
                    }}
                />
            )}
        </>
    );
}
